export default __webpack_public_path__ + "e65e354adbbbbb529bf2106931c71477.png";